import { render, staticRenderFns } from "./editSalesman.vue?vue&type=template&id=2127a841&scoped=true&"
import script from "./editSalesman.vue?vue&type=script&lang=js&"
export * from "./editSalesman.vue?vue&type=script&lang=js&"
import style0 from "./editSalesman.vue?vue&type=style&index=0&id=2127a841&lang=scss&scoped=true&"
import style1 from "./editSalesman.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2127a841",
  null
  
)

export default component.exports